import { withCloseAfterExited } from "@10duke/dukeui";
import {
  default as View,
  RemoveDeviceClientGroupModalProps
} from "./remove-device-client-group-modal-view";

const RemoveDeviceClientGroupModal = withCloseAfterExited<RemoveDeviceClientGroupModalProps>(View);
export default RemoveDeviceClientGroupModal;
